module.exports = __webpack_public_path__ + "img/arr_blue.d897ac27.svg";